import React, {FC, useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {PortableText} from "@portabletext/react"
import "katex/dist/katex.min.css";
import { InlineMath, BlockMath } from 'react-katex';

import {
    handleAddBulkAnswerToStudent, handleAddStudentTestQuestionFlag, handleFetchStudentTests,
    handleGetProblemsByStudentTestSectionId, handleGetTestByTestId, handleUpdateStudentTestQuestionFlag,
    handleUpdateStudentTestSectionStatus,
    handleUpdateStudentTestStatus
} from "Store/tests/actions";
import CustomModal from "../CustomModal/CustomModal";
import Spinner from "../../Spinner/Spinner";
import {makeSelectStudentActiveTest, makeSelectStudentActiveTestProblems} from "../../../../Store/tests/selectors";
import colors from "../../../../constants/colors";
import imageUrlBuilder from '@sanity/image-url'
import {createClient} from '@sanity/client'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faEye,
    faEyeSlash,
    faSquare,
    faBookmark,
    faChevronLeft,
    faChevronRight,
    faBars,
    faScrewdriverWrench,
    faFilter
} from '@fortawesome/free-solid-svg-icons'
import {orderSection} from "../../../../utils/OrderTestSections";
interface IProps {
    onClose: () => void;
    test: Test;
}

const DigitalTestModal: FC<IProps> = ({ test, onClose }) => {
    const dispatch = useDispatch();
    const [answered, setAnswered] = useState(null);
    const [showIndex, setShowIndex] = useState(false);
    const [showNextSection, setShowNextSection] = useState(false);
    const [showEndTest, setShowEndTest] = useState(false);
    const [disableTimeLeft, setDisableTimeLeft] = useState(false);
    const [showTimeLeft, setShowTimeLeft] = useState(false);
    const [showSpinner, setShowSpinner] = useState(true);
    const [section, setSection] = useState(null);
    const [testCache, setTestCache] = useState(test);
    const [isOpenTools, setIsOpenTools] = useState(false);
    const [isOpenFilter, setIsOpenFilter] = useState(false);
    const [showIntroduction, setShowIntroduction] = useState(true);
    const [showIntroductionFilter, setShowIntroductionFilter] = useState(false);
    const [filterBy, setFilterBy] = useState('question');
    const [selectedOption, setSelectedOption] = useState(null);
    const problems = useSelector(makeSelectStudentActiveTestProblems);
    const [timeLeft, setTimeLeft] = useState(null);
    const digitalTests = JSON.parse(localStorage.getItem("digitalTests")) || [];
    const studentActiveTest = useSelector(makeSelectStudentActiveTest);
    const myConfiguredSanityClient = createClient({
        projectId: 'pgglsqu3',
        dataset: 'production',
        useCdn: true,
        apiVersion: '2025-05-13',
    })
    const builder = imageUrlBuilder(myConfiguredSanityClient)

    function urlFor(source) {
        return builder.image(source)
    }

    useEffect(() => () => window.removeEventListener('popstate', popStateListener), [])

    useEffect(() => {
        window.addEventListener("popstate", popStateListener);
    }, []);
    const popStateListener = (message) => {
        onCloseDigitalTest()
        history.go(1);
    };

    function onCloseDigitalTest() {
        window.removeEventListener('popstate', popStateListener);
        onClose();
    }

    const toggleDropdownTools = () => {
        setIsOpenTools(prev => !prev);
    };

    const toggleAnswerEliminator = () => {
        testCache.answer_eliminator = testCache.answer_eliminator ? !testCache.answer_eliminator : true;
        testCache.answer_masking = false;
        if (testCache.answer_eliminator) {
            setSelectedOption(false);
            testCache.sections[section].problems[answered].answer = null;
        } else {
            testCache?.sections[section]?.problems[answered]?.question?.problemAnswerChoices.map(answer => answer.eliminate = false);
        }
        toggleDropdownTools();
    };

    const filterQuestionBy = (filter) => {
        setIsOpenFilter(prev => !prev);
        setFilterBy(filter);
    };

    const getCountByFilter = (filter) => {
        return testCache?.sections[section]?.problems.filter(problem => {
            switch (filter) {
                case "question":
                    return true;
                case "flagged":
                    return problem.flag.status == "FLAGGED";
                case "answered":
                    return problem.answer;
                case "unanswered":
                    return !problem.answer;
                default:
                    return true;
            }
        }).length;
    }

    const toggleAnswerMasking = () => {
        testCache.answer_masking = testCache.answer_masking ? !testCache.answer_masking : true;
        testCache.answer_eliminator = false;
        if (testCache.answer_masking) {
            setSelectedOption(false);
            testCache.sections[section].problems[answered].answer = null;
            testCache?.sections[section]?.problems[answered]?.question?.problemAnswerChoices.map(answer => answer.masking = true);
        } else {
            testCache?.sections[section]?.problems[answered]?.question?.problemAnswerChoices.map(answer => answer.masking = false);
        }
        toggleDropdownTools();
        console.log(testCache);
    };

    const setEliminateAnswer = (index) => {
        setSelectedOption(null);
        testCache.sections[section].problems[answered].answer = null;
        testCache.sections[section].problems[answered].question.problemAnswerChoices[index].eliminate = !testCache.sections[section].problems[answered].question.problemAnswerChoices[index].eliminate;
        if(testCache.sections[section].problems[answered].question.problemAnswerChoices.filter(answer => answer.eliminate).length == 3) {
            for(const key in testCache.sections[section].problems[answered].question.problemAnswerChoices) {
                if (testCache.sections[section].problems[answered].question.problemAnswerChoices[key].eliminate) {
                    continue;
                }
                setSelectedOption(String.fromCharCode(97 + Number(key)).toUpperCase());
            }
        }
        saveDigitalTest();
    };

    const setMaskingAnswer = (index) => {
        setSelectedOption(null);
        testCache.sections[section].problems[answered].question.problemAnswerChoices[index].masking = !testCache.sections[section].problems[answered].question.problemAnswerChoices[index].masking;
        saveDigitalTest();
    };

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const saveDigitalTest = () => {
        let updated = false;
        const updatedTests = digitalTests.map(dtest => {
            if (dtest.id == testCache.id) {
                updated = true;
                return testCache;
            }
            return dtest;
        });

        if (!updated) {
            updatedTests.push(testCache);
        }

        localStorage.setItem("digitalTests", JSON.stringify(updatedTests));
    };

    const clearDigitalTest = () => {
        const updatedTests = digitalTests.filter(dtest => dtest.id != testCache.id);

        if (updatedTests.length !== digitalTests.length) {
            localStorage.setItem("digitalTests", JSON.stringify(updatedTests));
        }
    };

    useEffect(() => {
        const digitalTest = digitalTests.filter(dtest => dtest?.id == test.id)
        if(digitalTest[0]?.id == test.id && test.status == 'STARTED' && test.sections.length == digitalTest[0].sections.length) {
            setTestCache(digitalTest[0]);
        } else {
            dispatch(handleUpdateStudentTestStatus({
                student_test_id: test.student_test_id,
                status: 'STARTED'
            }));
            testCache.status = 'STARTED';
            getSections();
        }
    }, []);
    //
    // useEffect(() => {
    //     if(studentActiveTest?.id == testCache?.id) {
    //         console.log(studentActiveTest.status != testCache.status);
    //         console.log(studentActiveTest);
    //         console.log(testCache);
    //         if(studentActiveTest.status != testCache.status) {
    //             // dispatch(handleUpdateStudentTestStatus({
    //             //     student_test_id: test.student_test_id,
    //             //     status: 'STARTED'
    //             // }));
    //             getSections();
    //         } else if(studentActiveTest.sections.length != testCache.sections.length) {
    //             getSections();
    //         }
    //     }
    // }, [studentActiveTest]);

    useEffect(() => {
        setNextSection();
    }, [testCache]);

    useEffect(() => {
        if (!showIntroduction) {
            setAnswered(0)
        }
    }, [showIntroduction]);

    useEffect(() => {
        if (showIntroduction && answered != null && answered == testCache.sections[section].section.description.introPages.length) {
            setShowIntroduction(false)
            setTimeLeft(testCache.sections[section].section.time_left != null ? testCache.sections[section].section.time_left-1 : testCache.sections[section].section.time_limit*60*(testCache.pace == null ? 1 : Number(testCache.pace))-1);
        }
        if (!showIntroduction && answered != null) {
            testCache.sections[section].problems[answered].start_timestamp = Date.now();
            saveDigitalTest();
        }
        scrollToHighlight();
    }, [answered])

    useEffect(() => {
        if (problems != null) {
            testCache.sections.map((sec,i) => {
                if (sec.section.id == problems?.test_section_id) {
                    if (!sec.problems?.length) {
                        sec.problems = problems.problems;
                        if (i == 0) {
                            setNextSection();
                        }
                    }
                }
            })
            saveDigitalTest();
        }
        if (problems != null && testCache.sections[section]?.problems?.length && testCache.sections[section].problems[answered].flag.id == null && problems[answered]?.flag?.id) {
            testCache.sections[section].problems[answered].flag.id = problems[answered].flag.id;
            saveDigitalTest();
        }
    }, [problems]);

    useEffect(() => {
        if(timeLeft != null && !showIntroduction) {
            if (section) {
                testCache.sections[section].section.time_left = timeLeft;
                saveDigitalTest();
            }
            if (timeLeft <= 0) {
                setShowTimeLeft(true);
                return;
            }

            const interval = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const hrs = Math.floor(seconds / 3600).toString().padStart(2, "0");
        const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
        const secs = (seconds % 60).toString().padStart(2, "0");
        return `${hrs} : ${mins} : ${secs}`;
    };
    const getSections = () => {
        test = { ...test, sections: orderSection(test.sections) }
        for(const section of test.sections) {
            dispatch(handleGetProblemsByStudentTestSectionId(test.id, section.id));
        }
    };

    const setNextSection = () => {
        for (const index in testCache?.sections) {
            if (testCache.sections[index].test_section_status == 'STARTED' && testCache.sections[index].problems) {
                testCache?.sections[index]?.problems.map(problem => problem.question?.problemAnswerChoices.map(answer => answer.masking = true));
                if (testCache?.sections[index]?.section.description) {
                    setShowIntroduction(true);
                }
                setSection(index);
                setAnswered(0)
                setTimeLeft(testCache.sections[index].section.time_left != null ? testCache.sections[index].section.time_left : testCache.sections[index].section.time_limit*60*(testCache.pace == null ? 1 : Number(testCache.pace)));
                setSelectedOption(testCache.sections[index].problems[0]?.answer ? testCache.sections[index].problems[0].answer : null);
                setShowSpinner(false);
                saveDigitalTest();
                return;
            }
        }
        for (const index in testCache?.sections) {
            if (testCache.sections[index].test_section_status == 'CREATED' && testCache.sections[index].problems) {
                dispatch(handleUpdateStudentTestSectionStatus({
                    studentTestSectionId: testCache.sections[index].id,
                    status: 'STARTED',
                    studentTestId: testCache.student_test_id
                }));
                setSelectedOption(testCache.sections[index].problems[0]?.answer ? testCache.sections[index].problems[0].answer : null);
                testCache.sections[index].test_section_status = 'STARTED';
                testCache.sections[index].start_timestamp = Date.now();
                testCache.sections[index].end_timestamp = Date.now();
                testCache.sections[index].time = 0;
                setSection(index);
                setAnswered(0)
                setTimeLeft(testCache.sections[index].section.time_left != null ? testCache.sections[index].section.time_left : testCache.sections[index].section.time_limit*60*(testCache.pace == null ? 1 : Number(testCache.pace)));
                if (testCache?.sections[index]?.section.description) {
                    setShowIntroduction(true);
                }
                setShowSpinner(false);
                saveDigitalTest();
                return;
            }
        }
        let completed = 0;
        for (const index in testCache?.sections) {
            if (testCache.sections[index].test_section_status == 'COMPLETED') {
                completed += 1;
            }
        }
        if(completed == testCache?.sections.length) {
            dispatch(handleUpdateStudentTestStatus({
                student_test_id: test.student_test_id,
                status: 'COMPLETED'
            }));
            setTimeout(() => {
                dispatch(handleFetchStudentTests());
                clearDigitalTest();
                onClose();
            }, 2000);
        }
    };

    const nextSection = () => {
        setShowNextSection(false);
        testCache.sections[section].test_section_status = 'COMPLETED';
        testCache.sections[section].end_timestamp = Date.now();
        testCache.sections[section].time = testCache.sections[section].time + testCache.sections[section].end_timestamp - testCache.sections[section].start_timestamp;
        saveDigitalTest()
        setShowSpinner(true);
        dispatch(handleAddBulkAnswerToStudent({
            student_test_id: testCache.student_test_id,
            answers: testCache.sections[section].problems.map(problem => {
                return {
                    test_problem_id : problem.id,
                    answer : problem.answer ?? null,
                    time : Math.ceil(problem.time/1000),
                }
            })
        }));
        //dispatch(handleGetTestByTestId(testCache.id));
        //setTimeout(() => {
            setTimeout(() => {
                dispatch(handleUpdateStudentTestSectionStatus({
                    studentTestSectionId: testCache.sections[section].id,
                    status: 'COMPLETED',
                    studentTestId: testCache.student_test_id
                }));

                setTimeout(() => {
                    setNextSection();
                }, 2000);
            }, 2000);
        //}, 2000);
    }
    const nextQuestion = () => {
        if (showIntroductionFilter && answered+1 == testCache.sections[section].section.description.introPages.length) {
            setQuestion(testCache.sections[section].problems[0], 0);
            return;
        }
        if (showIntroductionFilter && answered+1 < testCache.sections[section].section.description.introPages.length) {
            setAnswered(answered+1);
            return;
        }

        testCache.sections[section].problems[answered].answer = selectedOption;
        testCache.sections[section].problems[answered].end_timestamp = Date.now();
        testCache.sections[section].problems[answered].time = testCache.sections[section].problems[answered]?.time + testCache.sections[section].problems[answered]?.end_timestamp - testCache.sections[section].problems[answered].start_timestamp;
        setSelectedOption(testCache.sections[section].problems[answered+1]?.answer ? testCache.sections[section].problems[answered+1].answer : null);

        if (answered == testCache.sections[section].problems.length-1) {
            setShowNextSection(true);
        } else {
            setAnswered(answered+1);
        }
    };

    const setQuestion = (problem, index) => {
        setShowIntroductionFilter(false);
        testCache.sections[section].problems[answered].answer = selectedOption;
        testCache.sections[section].problems[answered].end_timestamp = Date.now();
        testCache.sections[section].problems[answered].time = testCache.sections[section].problems[answered]?.time + testCache.sections[section].problems[answered]?.end_timestamp - testCache.sections[section].problems[answered].start_timestamp;
        setSelectedOption(testCache.sections[section].problems[index]?.answer ? testCache.sections[section].problems[index].answer : null);
        setAnswered(index);
        saveDigitalTest();
    };

    const setIntroduction = (index) => {
        setAnswered(index);
        setShowIntroductionFilter(true);
        saveDigitalTest();
    };

    const prevQuestion = () => {
        testCache.sections[section].problems[answered].answer = selectedOption;
        testCache.sections[section].problems[answered].end_timestamp = Date.now();
        testCache.sections[section].problems[answered].time = testCache.sections[section].problems[answered]?.time + testCache.sections[section].problems[answered]?.end_timestamp - testCache.sections[section].problems[answered].start_timestamp;
        setSelectedOption(testCache.sections[section].problems[answered-1]?.answer ? testCache.sections[section].problems[answered-1].answer : null);
        setAnswered(answered-1);
    };

    const sectionTimeLeft = () => {
        nextSection();
        setShowTimeLeft(false);
    }

    const endTest = () => {
        setShowSpinner(true);
        testCache.sections[section].problems[answered].answer = selectedOption;
        testCache.sections[section].problems[answered].end_timestamp = Date.now();
        testCache.sections[section].problems[answered].time = testCache.sections[section].problems[answered]?.time + testCache.sections[section].problems[answered]?.end_timestamp - testCache.sections[section].problems[answered].start_timestamp;
        saveDigitalTest();
        dispatch(handleAddBulkAnswerToStudent({
            student_test_id: testCache.student_test_id,
            answers: testCache.sections[section].problems.map(problem => {
                return {
                    test_problem_id : problem.id,
                    answer : problem.answer ?? null,
                    time : Math.ceil(problem.time/1000),
                }
            })
        }));
        setTimeout(() => {
            for (const index in testCache?.sections) {
                setTimeout(() => {
                    dispatch(handleUpdateStudentTestSectionStatus({
                        studentTestSectionId: testCache.sections[index].id,
                        status: 'COMPLETED',
                        studentTestId: testCache.student_test_id
                    }));
                }, (Number(index)+1) * 1000);
            }
            setTimeout(() => {
                dispatch(handleUpdateStudentTestStatus({
                    student_test_id: test.student_test_id,
                    status: 'COMPLETED'
                }));
            }, 7500);
            clearDigitalTest();
            setShowEndTest(false);
            setTimeout(() => {
                dispatch(handleFetchStudentTests());
                onClose();
            }, 10000);
        }, 2000);
    };
    const portableComponents = useMemo(() => ({
        block: {
            normal: ({ children }) => (
                <p className="passage-content">
                    {children.map((child, index) =>
                        typeof child === "string" ? (
                            child
                        ) : (
                            child
                        )
                    )}
                </p>
            )
        },
        types: {
            latex: ({ value }) => {
                return <BlockMath>{value.body}</BlockMath>;
            },
            image: ({ value }) => {
                return <img alt="alt" src={urlFor(value.asset._ref).width(value.scaledWidth).url()}/>;
            }
        },
        marks: {
            span: ({ children }) => {
                return <span style={{ backgroundColor: "yellow", fontWeight: "bold" }}>{children}</span>;
            },
            textReference: ({ children, value }) => {
                if (testCache?.sections[section]?.problems[answered]?.question.passageTextReferenceId == value.reference_id) {
                    return (
                        <span className="scrollToHighliht" style={{backgroundColor: "yellow", padding: "0 3px"}}>
                            {children}
                        </span>
                    );
                }
                return children;
            },
        },
    }), [testCache?.sections[section]?.problems[answered]?.question]);

    const scrollToHighlight = () => {
        const element = document.querySelector('.scrollToHighliht') as HTMLElement;
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const addFlag = () => {
        if (testCache.sections[section].problems[answered].flag.status == "UN_FLAGGED") {
            testCache.sections[section].problems[answered].flag.status = "FLAGGED";
            saveDigitalTest();
            dispatch(handleAddStudentTestQuestionFlag({
                student_test_id: testCache.student_test_id,
                test_problem_id: testCache.sections[section].problems[answered].id}
            ));
        } else {
            testCache.sections[section].problems[answered].flag.status = "UN_FLAGGED";
            saveDigitalTest();
            dispatch(
                handleUpdateStudentTestQuestionFlag({
                    student_test_id: testCache.student_test_id,
                    test_problem_id: testCache.sections[section].problems[answered].id,
                    flag_id: testCache.sections[section].problems[answered].flag.id,
                    status: "UN_FLAGGED"
                })
            );
        }
    };

    const modal = (
        <CustomModal
            header={"Section"}
            message={
                "Once you end a module you will not be able to return. On the test day, you will not be able to move on until time expires. For this practice test click End Module to"
            }
            onClick={nextSection}
            onClose={() => setShowNextSection(false)}
            button="End Module"
            background={colors.studentBlue}
        />
    );
    const endModal = (
        <CustomModal
            header={"End test confirmation"}
            message={
                "Are you sure you want to end the test? You will not be able to resume it."
            }
            onClick={endTest}
            onClose={() => setShowEndTest(false)}
            button="YES, END THE TEST"
            background={colors.studentBlue}
        />
    );
    const timeleftModal = (
        <CustomModal
            header={"Out of time"}
            message={
                "The section time has run out. Go to the next section or end test."
            }
            onClick={sectionTimeLeft}
            onClose={sectionTimeLeft}
            button="OK"
            background={colors.studentBlue}
        />
    );

    return (
    <div className="digital-test-container">
          <CustomModal
              onClose={onClose}
              header=""
              onClick={() => {}}
              button=""
              message=""
              customClass="full-view digital-test-view"
          >
            {showSpinner ? (
                <Spinner showSpinner={showSpinner} />
            ) : (
                <>
                    {showIntroduction &&
                        <>

                            <div className="header-bar">
                                <div className="header-logo">ACT</div>
                            </div>
                            <div className="content-container">

                                <div className="problem-card">

                                    <div className="card-header">
                                        <h1 id="item-heading">{testCache?.sections[section]?.section.description.introPages[answered]?.introPage.title}</h1>
                                    </div>

                                    <div className="card-body">
                                        <div className="passage-container">
                                            <div className="passages" style={{textAlign: "left"}}>
                                                <div className="passage">
                                                    <div className="passage-introduction information">
                                                        <PortableText
                                                            value={testCache?.sections[section]?.section.description.introPages[answered]?.introPage.body}
                                                            components={portableComponents}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <button id="prev-button" disabled={answered == 0} onClick={() => setAnswered(answered-1)}
                                                className="btn-nav btn-prev" aria-label="Previous">
                                            <FontAwesomeIcon icon={faChevronLeft}/>
                                            <span>PREV</span>
                                        </button>
                                        <button id="next-button" onClick={() => setAnswered(answered+1)} className="btn-nav btn-next"
                                                aria-label="Next">
                                            <span>NEXT</span>
                                            <FontAwesomeIcon icon={faChevronRight}/>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </>
                    }
                    {!showIntroduction &&
                        <>
                        <div className="header-bar">
                            <div className="header-logo">ACT</div>
                            {<div className="header-menus">
                                <div className="dropdown-wrapper">
                                    <button
                                        className="dropdown-button"
                                        aria-controls="tools-dropdown"
                                        aria-expanded={isOpenTools}
                                        onClick={toggleDropdownTools}
                                    >
                                        <FontAwesomeIcon icon={faScrewdriverWrench}/>
                                        <span className="dropdown-label">TOOLS</span>
                                        <span className="chevron">
                                  <i className={`fas fa-chevron-${isOpenTools ? 'up' : 'down'}`}></i>
                                </span>
                                    </button>
                                    {isOpenTools && (
                                        <ul className="dropdown-list" id="tools-dropdown" aria-hidden={!isOpenTools}>
                                            <li className="dropdown-item" onClick={toggleAnswerEliminator}>Answer
                                                Eliminator
                                            </li>
                                            <li className="dropdown-item" onClick={toggleAnswerMasking}>Answer Masking
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>}
                            <div className="header-status">
                                <div className="status-info">
                                    <span className="label">ANSWERED</span>
                                    <span className="value"
                                          id="answered-counter">{testCache?.sections[section]?.problems.filter(problem => !!problem.answer).length} of {testCache?.sections[section]?.problems?.length}</span>
                                    <span className="label">TOTAL TIME LEFT</span>
                                    <span className="value"
                                          id="time-left">{disableTimeLeft && timeLeft ? '--:--:--' : formatTime(timeLeft)}</span>
                                </div>
                                <button className="btn-icon" onClick={() => setDisableTimeLeft(!disableTimeLeft)}>
                                    <FontAwesomeIcon icon={disableTimeLeft ? faEye : faEyeSlash}/></button>
                                <button className="btn-end-test" onClick={() => setShowEndTest(true)}>
                                    <FontAwesomeIcon icon={faSquare}/> END TEST
                                </button>
                            </div>
                        </div>
                        <div className="content-container">

                            <div className="problem-card">

                                <div className="card-header">
                                    {!showIntroductionFilter &&
                                        <h1 id="item-heading">{testCache?.sections[section]?.section?.name}: Question
                                            #{answered + 1}
                                        </h1>
                                    }
                                    {showIntroductionFilter &&
                                        <h1 id="item-heading">
                                            {testCache?.sections[section]?.section.description?.introPages[answered]?.introPage.title}
                                        </h1>
                                    }
                                    <button className="flag-button" aria-label="Flag question"
                                            onClick={() => addFlag()}>
                            <span className="flag-icon" aria-hidden="true">
                                <FontAwesomeIcon icon={faBookmark}/>
                            </span>
                                        {testCache.sections[section].problems[answered].flag.status == "FLAGGED" &&
                                            <span className="flag-label">FLAGGED</span>
                                        }
                                        {testCache.sections[section].problems[answered].flag.status == "UN_FLAGGED" &&
                                            <span className="flag-label">FLAG</span>
                                        }

                                    </button>

                                </div>

                                <div className="card-body">
                                    <div className="passage-container">
                                        <div className="passages">
                                            <div className="passage">
                                                <div className="passage-introduction">
                                                    {
                                                        !showIntroductionFilter &&
                                                        <PortableText
                                                            value={testCache?.sections[section]?.problems[answered]?.question?.passages ? testCache?.sections[section]?.problems[answered]?.question?.passages[0].body : testCache?.sections[section]?.problems[answered]?.question?.body}
                                                            components={portableComponents}
                                                        />
                                                    }
                                                    {
                                                        showIntroductionFilter &&
                                                        <PortableText
                                                            value={testCache?.sections[section]?.section.description.introPages[answered]?.introPage.body}
                                                            components={portableComponents}
                                                        />
                                                    }
                                                </div>
                                                {!showIntroductionFilter && testCache?.sections[section]?.section.name == 'Math' &&
                                                    <div className="question-container">
                                                        <div className="question">
                                                            <div className="stem">
                                                                <PortableText
                                                                    value={testCache?.sections[section]?.problems[answered]?.question?.passages != null ? testCache?.sections[section]?.problems[answered]?.question?.body : ''}
                                                                    components={portableComponents}
                                                                />
                                                            </div>
                                                            <div className="answer-choices">
                                                                {
                                                                    testCache?.sections[section]?.problems[answered]?.question?.problemAnswerChoices?.map((answer, key) => (
                                                                        <div className="answer-choice">
                                                                            <input type="radio"
                                                                                   disabled={testCache.answer_eliminator && answer.eliminate || testCache.answer_masking && answer.masking}
                                                                                   checked={selectedOption == String.fromCharCode(97 + key).toUpperCase()}
                                                                                   value={String.fromCharCode(97 + key).toUpperCase()}
                                                                                   onChange={handleChange}
                                                                                   id={"choice-" + key}
                                                                                   name={'question--' + answered}/>
                                                                            <label htmlFor={"choice-" + key} style={{
                                                                                width: testCache.answer_masking && answer.masking ? '96%': 'auto',
                                                                                border: testCache.answer_masking && answer.masking ? '1px solid black' : 'none',
                                                                            }}>
                                                                                <div className={testCache.answer_eliminator && answer.eliminate ? 'answer-content eliminated' : 'answer-content'} style={{opacity: testCache.answer_masking && answer.masking ? 0 : 1}}>
                                                                    <span
                                                                        className="answer-letter">{String.fromCharCode(97 + key).toUpperCase()}.</span>
                                                                                    <div className="answer-text">
                                                                                        <PortableText
                                                                                            value={testCache.answer_masking && answer.masking ? '' : answer?.body}
                                                                                            components={portableComponents}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </label>
                                                                            {testCache.answer_eliminator &&
                                                                                <button onClick={() => {
                                                                                    setEliminateAnswer(key)
                                                                                }}>X</button>}
                                                                            {testCache.answer_masking &&
                                                                                <button style={{marginLeft: 'auto'}} onClick={() => {
                                                                                    setMaskingAnswer(key)
                                                                                }}><FontAwesomeIcon
                                                                                    icon={testCache.answer_masking && !answer.masking ? faEye : faEyeSlash}/>
                                                                                </button>}
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {!showIntroductionFilter && testCache?.sections[section]?.section.name != 'Math' &&
                                        <>
                                            <div className="divider"></div>
                                            <div className="question-container">
                                                <div className="question">
                                                    <div className="stem">
                                                        <PortableText
                                                            value={testCache?.sections[section]?.problems[answered]?.question?.passages != null ? testCache?.sections[section]?.problems[answered]?.question?.body : ''}
                                                            components={portableComponents}
                                                        />
                                                    </div>
                                                    <div className="answer-choices">
                                                        {
                                                            testCache?.sections[section]?.problems[answered]?.question?.problemAnswerChoices?.map((answer, key) => (
                                                                <div className="answer-choice">
                                                                    <input type="radio"
                                                                           disabled={testCache.answer_eliminator && answer.eliminate || testCache.answer_masking && answer.masking}
                                                                           checked={selectedOption == String.fromCharCode(97 + key).toUpperCase()}
                                                                           value={String.fromCharCode(97 + key).toUpperCase()}
                                                                           onChange={handleChange} id={"choice-" + key}
                                                                           name={'question--' + answered}/>
                                                                    <label htmlFor={"choice-" + key} style={{
                                                                        width: testCache.answer_masking && answer.masking ? '96%': 'auto',
                                                                        border: testCache.answer_masking && answer.masking ? '1px solid black' : 'none',
                                                                    }}>
                                                                        <div
                                                                            className={testCache.answer_eliminator && answer.eliminate ? 'answer-content eliminated' : 'answer-content'}
                                                                            style={{opacity: testCache.answer_masking && answer.masking ? 0 : 1}}>

                                                                    <span
                                                                        className="answer-letter">{String.fromCharCode(97 + key).toUpperCase()}.</span>
                                                                            <div className="answer-text">
                                                                                <PortableText
                                                                                    value={testCache.answer_masking && answer.masking ? '' : answer?.body}
                                                                                    components={portableComponents}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </label>
                                                                    {testCache.answer_eliminator &&
                                                                        <button onClick={() => {
                                                                            setEliminateAnswer(key)
                                                                        }}>X</button>}
                                                                    {testCache.answer_masking &&
                                                                        <button style={{marginLeft: 'auto'}} onClick={() => {
                                                                            setMaskingAnswer(key)
                                                                        }}><FontAwesomeIcon
                                                                            icon={testCache.answer_masking && !answer.masking ? faEye : faEyeSlash}/>
                                                                        </button>}
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    <div className="divider"></div>
                                    {
                                        showIndex &&
                                        <div className="questions-index">
                                            <div className="header-menus filter-menu">
                                                <div className="dropdown-wrapper">
                                                    <div className="dropdown-wrapper">
                                                        <button
                                                            className="dropdown-button"
                                                            aria-controls="tools-dropdown"
                                                            aria-expanded={isOpenFilter}
                                                            onClick={() => setIsOpenFilter(prev => !prev)}
                                                            style={{color: 'black'}}
                                                        >
                                                            <FontAwesomeIcon icon={faFilter}/>
                                                            <span className="dropdown-label">Filter: </span>
                                                            <span className="dropdown-label">{filterBy}</span>
                                                        </button>
                                                        {isOpenFilter && (
                                                            <ul className="dropdown-list" id="tools-dropdown"
                                                                style={{zIndex: 1}}
                                                                aria-hidden={!isOpenFilter}>
                                                                <li className="dropdown-item"
                                                                    onClick={() => filterQuestionBy('questions')}>All
                                                                    Questions
                                                                </li>
                                                                <li className="dropdown-item"
                                                                    onClick={() => filterQuestionBy('flagged')}>Flagged
                                                                    ({getCountByFilter('flagged')})
                                                                </li>
                                                                <li className="dropdown-item"
                                                                    onClick={() => filterQuestionBy('answered')}>Answered
                                                                    ({getCountByFilter('answered')})
                                                                </li>
                                                                <li className="dropdown-item"
                                                                    onClick={() => filterQuestionBy('unanswered')}>Unanswered
                                                                    ({getCountByFilter('unanswered')})
                                                                </li>
                                                            </ul>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="questions-index">
                                                {
                                                    testCache?.sections[section]?.section.description.introPages.map((page, key) => (
                                                        <div className="utd-index-entry" onClick={() => {
                                                            setIntroduction(key)
                                                        }}>
                                                            <header className="utd-index-entry-header" >{page.introPage.page_title}</header>
                                                        </div>
                                                    ))
                                                }
                                                {
                                                    testCache?.sections[section]?.problems.filter(problem => {
                                                        switch (filterBy) {
                                                            case "question":
                                                                return true;
                                                            case "flagged":
                                                                return problem.flag.status == "FLAGGED";
                                                            case "answered":
                                                                return problem.answer;
                                                            case "unanswered":
                                                                return !problem.answer;
                                                            default:
                                                                return true;
                                                        }
                                                    }).map((problem, key) => (
                                                        <div className="utd-index-entry" onClick={() => {
                                                            setQuestion(problem, problem.question_number-1)
                                                        }}>
                                                            <header className="utd-index-entry-header">Question #{problem.question_number}</header>
                                                            <div className="utd-index-entry-body">
                                                                {problem.answer &&
                                                                    <span className="utd-badge-answered">Answered</span>
                                                                }
                                                                <section className="utd-index-item" style={{maxWidth: problem.answer ? '84%': '100%'}}>

                                                                    {
                                                                        problem.question?.body &&
                                                                        (
                                                                            <PortableText
                                                                                value={problem.question.body}
                                                                                components={portableComponents}
                                                                            />
                                                                        )
                                                                    }
                                                                </section>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            </div>
                                        }

                                    </div>

                                    <div className="card-footer">
                                        <button id="prev-button" disabled={answered == 0} onClick={prevQuestion}
                                                className="btn-nav btn-prev" aria-label="Previous">
                                            <FontAwesomeIcon icon={faChevronLeft}/>
                                            <span>PREV</span>
                                        </button>
                                        <button id="next-button" onClick={nextQuestion} className="btn-nav btn-next"
                                                aria-label="Next">
                                            <span>NEXT</span>
                                            <FontAwesomeIcon icon={faChevronRight}/>
                                        </button>
                                    </div>

                                </div>


                                <aside className="side-menu">
                                    <button className="menu-button" onClick={() => setShowIndex(!showIndex)} role="menuitem"
                                            aria-label="Index">
                                <span className="icon" aria-hidden="true">
                                    <FontAwesomeIcon icon={faBars}/>
                                </span>
                                        <label className="menu-label">INDEX</label>
                                    </button>
                                </aside>
                            </div>
                            {showNextSection && modal}
                            {showEndTest && endModal}
                            {showTimeLeft && timeleftModal}
                        </>
                    }
                </>
            )
            }
          </CustomModal>
    </div>
    );
};

export default DigitalTestModal;
